import React from 'react';
import { CogIcon, ClipboardListIcon, MapPinIcon, BarChart3Icon, ShieldCheckIcon, UsersIcon, TruckIcon, WrenchIcon, CalendarIcon, FileTextIcon, AlertTriangleIcon, ActivityIcon } from 'lucide-react';
import { SolutionPageLayout } from '../../components/SolutionPageLayout';
const features = [{
  icon: ClipboardListIcon,
  title: 'Work Order Management',
  description: 'Create, assign, and track work orders for maintenance, installation, and service operations. Manage priorities, dependencies, and resource allocation.'
}, {
  icon: MapPinIcon,
  title: 'Asset & Site Management',
  description: 'Track equipment, facilities, and infrastructure across multiple sites. Maintain asset hierarchies, specifications, and complete maintenance history.'
}, {
  icon: WrenchIcon,
  title: 'Preventive Maintenance',
  description: 'Schedule PM tasks based on time, usage, or condition. Automate work order generation and ensure critical equipment stays operational.'
}, {
  icon: CalendarIcon,
  title: 'Resource Scheduling',
  description: 'Schedule crews, equipment, and vehicles across jobs and locations. Optimize utilization and avoid conflicts with visual scheduling tools.'
}, {
  icon: ShieldCheckIcon,
  title: 'Safety & Compliance',
  description: 'Track safety incidents, manage permits, and maintain compliance documentation. Ensure your operations meet regulatory requirements at every site.'
}, {
  icon: TruckIcon,
  title: 'Fleet & Logistics',
  description: 'Manage vehicle fleets, track deliveries, and coordinate logistics across your operation. Monitor fuel, maintenance, and utilization.'
}, {
  icon: UsersIcon,
  title: 'Contractor Management',
  description: 'Onboard, credential, and manage contractors and subcontractors. Track certifications, insurance, and performance across projects.'
}, {
  icon: FileTextIcon,
  title: 'Project & Job Costing',
  description: 'Track costs by project, job, or work order. Capture labor, materials, equipment, and overhead for accurate profitability analysis.'
}, {
  icon: AlertTriangleIcon,
  title: 'Incident Management',
  description: 'Report, investigate, and resolve operational incidents. Track root causes, corrective actions, and trends to prevent recurrence.'
}, {
  icon: BarChart3Icon,
  title: 'Operational Analytics',
  description: 'Monitor KPIs across sites, teams, and equipment. Dashboards for uptime, response times, cost per unit, and operational efficiency.'
}, {
  icon: CogIcon,
  title: 'Process Automation',
  description: 'Automate routine operational workflows — from approval chains to status notifications to report generation. Reduce manual overhead.'
}, {
  icon: ActivityIcon,
  title: 'Real-Time Monitoring',
  description: 'Connect to sensors and control systems for real-time operational visibility. Set thresholds, trigger alerts, and respond to conditions as they happen.'
}];
export function IndustrialOperationsPage() {
  return <SolutionPageLayout label="Industrial Operations" title="Operational software for complex industrial environments" subtitle="Whether you're managing field operations, facility maintenance, or multi-site logistics, Thruline builds the operational backbone your team needs to stay coordinated and compliant." features={features} data-id="element-415" />;
}